import {ConditionException} from '../../modules/error';
import {conditions, latMeasure, lngMeasure} from './';

function _munge() {//데이터 갱신시
  //TODO: Limit 기능 이용해서 dimension의 unique한 개수 조절
  let conditionFunc = function (dimensions, measures) {
    const field = this.__execs__.field;
    if (this.addr()) { //주소 모드
      if (measures.length < 1) throw new ConditionException();
      field.addr = measures[0];
      field.lat = latMeasure;
      field.lng = lngMeasure;
      if (measures.length === 2) {
        field.radius = measures[1];
        return conditions[0];
      } else if (measures.length === 1) {
        return conditions[1];
      } 
    } else {
      if (measures.length < 2) throw new ConditionException()
      if (measures.length === 3) {
        field.lat = measures[0]
        field.lng = measures[1]
        field.radius = measures[2];
        return conditions[0];
      } else if (measures.length === 2) {
        field.lat = measures[0]
        field.lng = measures[1]
        return conditions[1];
      } 
    }
    if (dimensions.length === 1) {
      field.name = dimensions[0];
    }
    throw new ConditionException();
  };
  this.condition(conditionFunc); // condiion 설정
  this.limitRows();
  const field = this.__execs__.field;
  if (this.isSized()) this.data().sort(function (a, b) { return b[field.radius.field] - a[field.radius.field]; });
  this.__execs__.munged = this.data();
}

export default _munge;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/marker-map/_munge.js